import { useLocation } from 'react-router';
import { Link } from './ScopedLink';
import { selectedBuilding } from './building-scope';
import { taskReturnContext } from './task-navigation';

/** A queue return never accepts an external URL or broadens the current scope. */
export function TaskReturnLink() {
  const location = useLocation();
  const context = taskReturnContext(location.state, selectedBuilding(location.pathname, location.search));
  return context ? <Link className="back-link" to={context.to}
    state={{ taskSearch: context.search, taskFocusKey: context.focusKey }}>Return to assigned tasks</Link> : null;
}
